import { Box, Theme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import useAuth from "../hooks/useAuth";
import Sidebar from "./dashboard/Drawer";
import Header from "./dashboard/Header";


export default function DashboardLayout() {
  useAuth();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <Box
        sx={(theme) => ({
          width: "100%",
          maxWidth: "none",
          marginRight: "auto",
          marginLeft: "auto",

          [theme.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: 768,
          },
        })}
      >
      <Header />

      <Box
        sx={{
          paddingTop: "67px",
          backgroundColor: "white",
          position: "relative",
        }}
      >
        <Sidebar />
        <Box
          sx={(theme) => ({
            backgroundColor: "white",
            marginLeft: 0,

            [theme.breakpoints.up("md")]: {
              width: `calc(100% - 250px)`,
              marginLeft: "250px",
            },
          })}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
    </>
  );
}
